<template>
  <div class="card card-modal">
    <div class="card-header">
      Selecionar mensagem
    </div>

    <div class="alert col alert-warning col" v-if="lista.length == 0">
      <strong>Atenção!</strong> Nenhuma agenda encontrada
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col">

          <table class="table table-dark table-striped pointer" id="tableSelectAgenda">
            <tbody >
              <tr v-for="msg in lista" :key="msg._id" :class="{ rowActive: msg._id == selectedMsg._id }" @click="selectedMsg = msg">
                <td> {{msg.mensagem}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row card-footer ">
      <div class="col">
        <button class="btn btn-success btn-sm col-6 btn-danger" @click="$emit('close')">
          Fechar
        </button>
        <button class="btn btn-success btn-sm col-6 btn-success" @click="select()">
          Selecionar
        </button>
      </div>
    </div>
  </div>

</template>

<script>

import EventBus from './../../core/eventBus';

export default {
  data() {
    return {
      selectedMsg: {},
      lista: [],
    }
  },
  methods: {
    async listAll(){

      let response = await this.$http.get(`/v1/v3/mensagens-pre/0/1000`);
      if (response.data) {
        this.lista = response.data;
        this.selectedMsg = this.lista[0];
      }
    },
    select(){
      this.$emit('close');
      EventBus.$emit('setMensagem', this.selectedMsg);
    }
  },
  async mounted() {
    this.listAll();
  },

};
</script>
